/**
* This is a TypeGen auto-generated file.
* Any changes made to this file will be lost when the file is regenerated.
*/

import {Observable} from "rxjs";
import {Injectable, Injector} from "@angular/core";
import {HttpEvent} from "@angular/common/http";
import {ApiServiceBase} from "../../api-service-base";
import {AudioChannelGroup} from "../model/audio-channel-group";
import {AudioInputChannel} from "../model/audio-input-channel";
import {AudioOutputChannel} from "../model/audio-output-channel";
import {DeleteRequest} from "../model/delete-request";
import {ListData} from "../model/list-data";
import {NetworkAudioInputChannel} from "../model/network-audio-input-channel";
import {PhoneAudioInputChannel} from "../model/phone-audio-input-channel";
import {SuccessResponse} from "../model/success-response";

@Injectable({
    providedIn: "root",
})
export class SimAudioChannelService extends ApiServiceBase {
	constructor(injector: Injector) {
        super(injector);
	}
    public deleteAudioChannelGroup(audioChannelGroupId: string) {
        return super.get<boolean>(`/api/AudioChannel/DeleteAudioChannelGroup`, {audioChannelGroupId: audioChannelGroupId});
    }

    public deleteAudioInputChannel(request: DeleteRequest) {
        return super.post<boolean>(`/api/AudioChannel/DeleteAudioInputChannel`, request);
    }

    public deleteAudioOutputChannel(request: DeleteRequest) {
        return super.post<boolean>(`/api/AudioChannel/DeleteAudioOutputChannel`, request);
    }

    public deleteNetworkAudioInputChannel(request: DeleteRequest) {
        return super.post<boolean>(`/api/AudioChannel/DeleteNetworkAudioInputChannel`, request);
    }

    public deletePhoneAudioInputChannel(request: DeleteRequest) {
        return super.post<boolean>(`/api/AudioChannel/DeletePhoneAudioInputChannel`, request);
    }

    public getAllAudioInputChannels() {
        return super.get<AudioInputChannel[]>(`/api/AudioChannel/GetAllAudioInputChannels`, );
    }

    public getAnyVogAudioInputChannels(recorderMappingId: string) {
        return super.get<AudioInputChannel[]>(`/api/AudioChannel/GetAnyVogAudioInputChannels`, {recorderMappingId: recorderMappingId});
    }

    public getAnyVopAudioInputChannels(recorderMappingId: string) {
        return super.get<AudioInputChannel[]>(`/api/AudioChannel/GetAnyVopAudioInputChannels`, {recorderMappingId: recorderMappingId});
    }

    public getAnyVttAudioInputChannels(recorderMappingId: string) {
        return super.get<AudioInputChannel[]>(`/api/AudioChannel/GetAnyVttAudioInputChannels`, {recorderMappingId: recorderMappingId});
    }

    public getAudioChannelGroups() {
        return super.get<AudioChannelGroup[]>(`/api/AudioChannel/GetAudioChannelGroups`, );
    }

    public getAudioInputChannels() {
        return super.get<AudioInputChannel[]>(`/api/AudioChannel/GetAudioInputChannels`, );
    }

    public getAudioOutputChannels() {
        return super.get<AudioOutputChannel[]>(`/api/AudioChannel/GetAudioOutputChannels`, );
    }

    public getAudioOutputChannelsForRecorderAndTrainingRoom(recorderId: string, trainingRoomId: string, includeVop: boolean, includeVtt: boolean, includeVog: boolean) {
        return super.get<AudioOutputChannel[]>(`/api/AudioChannel/GetAudioOutputChannelsForRecorderAndTrainingRoom`, {recorderId: recorderId, trainingRoomId: trainingRoomId, includeVop: includeVop, includeVtt: includeVtt, includeVog: includeVog});
    }

    public getFilteredAudioInputChannels(searchTerm: string, searchColumn: string, sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<ListData<AudioInputChannel>>(`/api/AudioChannel/GetFilteredAudioInputChannels`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getFilteredAudioOutputChannels(searchTerm: string, searchColumn: string, sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<ListData<AudioOutputChannel>>(`/api/AudioChannel/GetFilteredAudioOutputChannels`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getFilteredNetworkAudioInputChannels(searchTerm: string = "", searchColumn: string = "", sortColumn: string = "", sortAscending: boolean = true, page: number = 0, pageSize: number = 10000) {
        return super.get<ListData<NetworkAudioInputChannel>>(`/api/AudioChannel/GetFilteredNetworkAudioInputChannels`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getFilteredPhoneAudioInputChannels(searchTerm: string, searchColumn: string, sortColumn: string, sortAscending: boolean, page: number, pageSize: number) {
        return super.get<ListData<PhoneAudioInputChannel>>(`/api/AudioChannel/GetFilteredPhoneAudioInputChannels`, {searchTerm: searchTerm, searchColumn: searchColumn, sortColumn: sortColumn, sortAscending: sortAscending, page: page, pageSize: pageSize});
    }

    public getPhoneAudioInputChannels() {
        return super.get<PhoneAudioInputChannel[]>(`/api/AudioChannel/GetPhoneAudioInputChannels`, );
    }

    public getUnassignedAudioChannelGroup() {
        return super.get<AudioChannelGroup>(`/api/AudioChannel/GetUnassignedAudioChannelGroup`, );
    }

    public updateAudioChannelGroup(audioChannelGroup: AudioChannelGroup) {
        return super.post<boolean>(`/api/AudioChannel/UpdateAudioChannelGroup`, audioChannelGroup);
    }

    public updateAudioInputChannel(audioInputChannelToUpdate: AudioInputChannel) {
        return super.post<SuccessResponse>(`/api/AudioChannel/UpdateAudioInputChannel`, audioInputChannelToUpdate);
    }

    public updateAudioInputChannels(audioDeviceChannels: AudioInputChannel[]) {
        return super.post<boolean>(`/api/AudioChannel/UpdateAudioInputChannels`, audioDeviceChannels);
    }

    public updateAudioOutputChannel(audioDeviceChannel: AudioOutputChannel) {
        return super.post<boolean>(`/api/AudioChannel/UpdateAudioOutputChannel`, audioDeviceChannel);
    }

    public updateAudioOutputChannels(audioDeviceChannels: AudioOutputChannel[]) {
        return super.post<boolean>(`/api/AudioChannel/UpdateAudioOutputChannels`, audioDeviceChannels);
    }

    public updateNetworkAudioInputChannel(audioInputChannelToUpdate: NetworkAudioInputChannel) {
        return super.post<boolean>(`/api/AudioChannel/UpdateNetworkAudioInputChannel`, audioInputChannelToUpdate);
    }

    public updateNetworkAudioInputChannels(audioDeviceChannels: NetworkAudioInputChannel[]) {
        return super.post<boolean>(`/api/AudioChannel/UpdateNetworkAudioInputChannels`, audioDeviceChannels);
    }

    public updatePhoneAudioInputChannel(audioDeviceChannel: PhoneAudioInputChannel) {
        return super.post<boolean>(`/api/AudioChannel/UpdatePhoneAudioInputChannel`, audioDeviceChannel);
    }

    public updatePhoneAudioInputChannels(audioDeviceChannels: PhoneAudioInputChannel[]) {
        return super.post<boolean>(`/api/AudioChannel/UpdatePhoneAudioInputChannels`, audioDeviceChannels);
    }

    public upsertAudioChannelGroup(audioChannelGroup: AudioChannelGroup) {
        return super.post<boolean>(`/api/AudioChannel/UpsertAudioChannelGroup`, audioChannelGroup);
    }

    public upsertAudioChannelGroups(audioChannelGroups: AudioChannelGroup[]) {
        return super.post<boolean>(`/api/AudioChannel/UpsertAudioChannelGroups`, audioChannelGroups);
    }
}